import DocumentDecentralizePreview from "./document-decentralize-preview";
import DocumentViewDecentralize from "./document-view-decentralize";
import DocumentViewPreview from "./document-view-preview";

const DocumentView = ({ viewMode, document }: { viewMode: string; document?: any }) => {
  if (viewMode === "decentralize") {
    return <DocumentViewDecentralize document={document} />;
  }
  if (viewMode === "decentralize-preview") {
    return <DocumentDecentralizePreview document={document} />;
  }
  return <DocumentViewPreview viewMode={viewMode} />;
};

export default DocumentView;
